package com.veldekar.`data`

import com.veldekar.model.Bookmark
import com.veldekar.model.BookmarkCategory
import com.veldekar.model.VeldekarDate
import kotlin.collections.List
import kotlin.collections.listOf

public object TimelineData {
    public val categories: List<BookmarkCategory> = listOf(
                BookmarkCategory(
                    icon = "✈️",
                    title = "Travel",
                    bookmarks = listOf(
                        Bookmark(
                            icon = "⚔️",
                            title = "1st Quest",
                            startDate = VeldekarDate("Newgrowth", 8),
                            endDate = VeldekarDate("Newgrowth", 17),
                            targetAnchor = "newgrowth-8"
                        ),
                        Bookmark(
                            icon = "🏘️",
                            title = "Dorb",
                            startDate = VeldekarDate("Newgrowth", 17),
                            endDate = VeldekarDate("Newgrowth", 23),
                            targetAnchor = "newgrowth-17"
                        ),
                        Bookmark(
                            icon = "🔦",
                            title = "Imperial Darkway",
                            startDate = VeldekarDate("Newgrowth", 26),
                            endDate = VeldekarDate("Newgrowth", 36),
                            targetAnchor = "newgrowth-26"
                        ),
                        Bookmark(
                            icon = "🌳",
                            title = "Zedj",
                            startDate = VeldekarDate("Newgrowth", 40),
                            endDate = VeldekarDate("Newgrowth", 50),
                            targetAnchor = "newgrowth-40"
                        ),
                        Bookmark(
                            icon = "🏝️",
                            title = "Well's Bounty",
                            startDate = VeldekarDate("Newgrowth", 56),
                            endDate = VeldekarDate("Newgrowth", 71),
                            targetAnchor = "newgrowth-56"
                        ),
                        Bookmark(
                            icon = "🏜️",
                            title = "Thardos Ruins",
                            startDate = VeldekarDate("Newgrowth", 72),
                            endDate = VeldekarDate("Newgrowth", 74),
                            targetAnchor = "newgrowth-72"
                        ),
                        Bookmark(
                            icon = "🌴",
                            title = "Seshiss",
                            startDate = VeldekarDate("Newgrowth", 81),
                            endDate = VeldekarDate("Shimmer", 3),
                            targetAnchor = "newgrowth-81"
                        ),
                        Bookmark(
                            icon = "⛵",
                            title = "Sailing to Ostvel",
                            startDate = VeldekarDate("Shimmer", 11),
                            endDate = VeldekarDate("Shimmer", 20),
                            targetAnchor = "shimmer-11"
                        ),
                        Bookmark(
                            icon = "🌲",
                            title = "Gideon Forest",
                            startDate = VeldekarDate("Shimmer", 21),
                            endDate = VeldekarDate("Shimmer", 29),
                            targetAnchor = "shimmer-21"
                        )
                    )
                ),
                BookmarkCategory(
                    icon = "🛡️",
                    title = "Shards",
                    bookmarks = listOf(
                        Bookmark(
                            icon = "🛡️",
                            title = "Shard 1 (Cave north of Ybrallan)",
                            startDate = VeldekarDate("Newgrowth", 12),
                            endDate = null,
                            targetAnchor = "newgrowth-12"
                        ),
                        Bookmark(
                            icon = "🦸",
                            title = "Damon calls heroes Shield Bearers",
                            startDate = VeldekarDate("Newgrowth", 17),
                            endDate = null,
                            targetAnchor = "newgrowth-17"
                        ),
                        Bookmark(
                            icon = "🏰",
                            title = "Shard 2 (Stronghold near Zedj)",
                            startDate = VeldekarDate("Newgrowth", 52),
                            endDate = null,
                            targetAnchor = "newgrowth-52"
                        ),
                        Bookmark(
                            icon = "🔮",
                            title = "Learn to scry Shards of Concar",
                            startDate = VeldekarDate("Newgrowth", 52),
                            endDate = null,
                            targetAnchor = "newgrowth-52"
                        ),
                        Bookmark(
                            icon = "🏜️",
                            title = "Shard 3 (Thardos Family Ruins)",
                            startDate = VeldekarDate("Newgrowth", 74),
                            endDate = null,
                            targetAnchor = "newgrowth-74"
                        ),
                        Bookmark(
                            icon = "🐙",
                            title = "Shard 4 (Lair of Flar'Melkhis)",
                            startDate = VeldekarDate("Shimmer", 5),
                            endDate = null,
                            targetAnchor = "shimmer-5"
                        ),
                        Bookmark(
                            icon = "🦊",
                            title = "Shard 5 (Lord Fox in Freeburg)",
                            startDate = VeldekarDate("Shimmer", 10),
                            endDate = null,
                            targetAnchor = "shimmer-10"
                        )
                    )
                ),
                BookmarkCategory(
                    icon = "👪",
                    title = "Group Composition",
                    bookmarks = listOf(
                        Bookmark(
                            icon = "👋",
                            title = "Jemrin leaves",
                            startDate = VeldekarDate("Newgrowth", 17),
                            endDate = null,
                            targetAnchor = "newgrowth-17"
                        ),
                        Bookmark(
                            icon = "⛪️",
                            title = "Falorn joins",
                            startDate = VeldekarDate("Newgrowth", 17),
                            endDate = null,
                            targetAnchor = "newgrowth-17"
                        ),
                        Bookmark(
                            icon = "👋",
                            title = "Gorem leaves",
                            startDate = VeldekarDate("Newgrowth", 78),
                            endDate = null,
                            targetAnchor = "newgrowth-78"
                        ),
                        Bookmark(
                            icon = "🧙‍♂️",
                            title = "Meet Korvis",
                            startDate = VeldekarDate("Newgrowth", 83),
                            endDate = null,
                            targetAnchor = "newgrowth-83"
                        ),
                        Bookmark(
                            icon = "🐄",
                            title = "Aloysius awakens",
                            startDate = VeldekarDate("Shimmer", 7),
                            endDate = null,
                            targetAnchor = "shimmer-7"
                        ),
                        Bookmark(
                            icon = "👋",
                            title = "Korvis leaves",
                            startDate = VeldekarDate("Shimmer", 15),
                            endDate = null,
                            targetAnchor = "shimmer-15"
                        )
                    )
                )
            )
}
